import { module } from './helper';
export { default as settingsHelper, Mutations } from './helper';

import signup from '@/api/signup';

export default {
  namespaced: true,

  state: {},

  getters: {},

  actions: {
    company(_, companyNumber) {
      return signup.companyInfo(companyNumber);
    },
  },

  mutations: {},
} as module;
